import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import styled from 'styled-components';

// import MenuRecommendationCard from 'components/card/MenuRecommendationCard';

import useMenuBar from 'hooks/menu/useMenuBar';
import useMenuCommon from 'hooks/menu/useMenuCommon';

import { menuBarV2Const } from 'constants/common/menu/menuBarConst';

import theme from 'styles/token/color';

import LeftSubMenu from './menu/LeftSubMenu';
import RightSubMenu from './menu/RightSubMenu';

const MenuBar = () => {
  const { subContent, onMenuBarOpen, onMenuBarClose } = useMenuBar();
  const [openDepthIndex, setOpenDepthIndex] = useState(0);
  const { pathname } = useLocation();
  useMenuCommon();

  // 현재 페이지에 맞는 서브 메뉴 활성화 (서비스 메뉴 해당)
  React.useEffect(() => {
    if (!subContent?.isOpen || !subContent?.items) return;

    let matchIndex = 0; // 매칭되는 항목이 없을 경우 기본값 0

    subContent.items.forEach((item) => {
      // 다중 계층 모드(지도, 검색, 경로 등이 있는 구조)일 때만 openDepthIndex가 동작함
      if (item.depth === true) {
        const flatSections =
          item.groups?.flatMap((g) => g.sections || []) || [];

        const found = flatSections.findIndex((section) => {
          // 1. 섹션 자체의 path가 현재 URL에 포함되어 있는지 확인
          if (section.path && pathname.includes(section.path)) return true;

          // 2. 하위 리스트(apis 또는 verticals) 탐색
          const targetItems = section.apis || section.verticals;

          if (targetItems && Array.isArray(targetItems)) {
            return targetItems.some((subItem) => {
              if (subItem.path && pathname.includes(subItem.path)) return true;
              if (subItem.content && Array.isArray(subItem.content)) {
                return subItem.content.some(
                  (contentItem) =>
                    contentItem.path && pathname.includes(contentItem.path)
                );
              }
              return false;
            });
          }
          return false;
        });
        if (found !== -1) {
          matchIndex = found;
        }
      }
    });

    setOpenDepthIndex(matchIndex);
  }, [subContent?.title, subContent?.isOpen, subContent?.items, pathname]);

  return (
    <NavWrapper aria-label="main navigation" onMouseLeave={onMenuBarClose}>
      {/* 메인 메뉴 */}
      <MainMenuContainer>
        <MainMenuList>
          {menuBarV2Const.map((item, idx) => (
            <MainMenuItem
              key={`main-menu-${idx}`}
              onMouseEnter={() => onMenuBarOpen(item)}
              onClick={() => onMenuBarOpen(item)}
              $isActive={subContent?.isOpen && subContent?.title === item.title}
            >
              <MenuBadgeTitle>{item.title}</MenuBadgeTitle>
            </MainMenuItem>
          ))}
        </MainMenuList>
      </MainMenuContainer>
      {/* 서브 메뉴 */}
      {subContent?.isOpen && (
        <SubMenuContainer>
          <SubMenuInner>
            {/* 1) 서브 좌측 메뉴 */}
            <LeftMenu>
              {subContent?.items?.map((item) =>
                item.depth === true ? (
                  // 1-1) 다중 계층 구조
                  (() => {
                    let accumulatedIndex = 0;
                    return item.groups?.map((group, i) => {
                      const startIndex = accumulatedIndex;
                      const count = group.sections?.length || 0;
                      accumulatedIndex += count;

                      return (
                        <LeftSubMenu
                          key={`sub-left-${i}`}
                          subItem={{ label: group.label }}
                          items={group.sections || []}
                          openDepthIndex={openDepthIndex - startIndex}
                          setOpenDepthIndex={(idx) =>
                            setOpenDepthIndex(startIndex + idx)
                          }
                        />
                      );
                    });
                  })()
                ) : (
                  // 1-2) 단일 계층 구조
                  <LeftSubMenu
                    key={`sub-left-single`}
                    items={[{ title: subContent.title }]}
                  />
                )
              )}
            </LeftMenu>
            {/* 2) 서브 우측 메뉴 */}
            <RightMenu>
              {subContent?.items.map((item) =>
                item.depth === true
                  ? // 2-1) 단일 계층 구조 (소개, 문의하기)
                    item.groups
                      ?.flatMap((group) => group.sections || [])
                      .map(
                        (link, i) =>
                          openDepthIndex === i && (
                            <RightSubMenu
                              key={`sub-right-${i}`}
                              item={link}
                              openDepthIndex={openDepthIndex}
                              index={i}
                              onMenuBarClose={onMenuBarClose}
                              // icon={<IoArrowForwardOutline className="arrow" />}
                            />
                          )
                      )
                  : // 2-2) 다중 계층 구조 (지도, 검색, 탐색)
                    item.sections.map((link, i) => (
                      <RightSubMenu
                        key={`sub-right-link-${i}`}
                        item={{
                          title: link.title,
                          description: link.description,
                          path: link.path,
                          apis: link.apis,
                          content: link.content,
                          ...link,
                        }}
                        onMenuBarClose={onMenuBarClose}
                        // icon={<IoArrowForwardOutline className="arrow" />}
                      />
                    ))
              )}
            </RightMenu>
            {/* 3) 추천 영역 */}
            {/* ⚠️ 260305 추천 섹션 카드 임시 제거 */}
            {/* {(() => {
              // 현재 활성화된 아이템 찾기 (전체 섹션 플랫화 후 인덱스 매칭)
              const flatItems = subContent?.items?.flatMap((item) =>
                item.depth === true
                  ? item.groups?.flatMap((g) => g.sections || []) || []
                  : item.sections || []
              );
              const activeItem = flatItems?.[openDepthIndex];

              return (
                activeItem?.recommendation && (
                  <MenuRecommendationCard
                    data={activeItem.recommendation}
                    onMenuBarClose={onMenuBarClose}
                  />
                )
              );
            })()} */}
          </SubMenuInner>
        </SubMenuContainer>
      )}
    </NavWrapper>
  );
};

export default MenuBar;

const menuFontSizeProps = {
  item: '16px',
  title: '16px',
  description: '12px',
};

const NavWrapper = styled.nav``;

const MainMenuContainer = styled.div`
  // max-width: 1280px;
  max-width: 1440px;
  margin: 0 auto;
`;

const MainMenuList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const MainMenuItem = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  height: 66px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  line-height: 1;
  color: ${theme.color.white};
  font-size: ${menuFontSizeProps.item};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: ${({ $isActive }) => ($isActive ? '100%' : '0')};
    height: 2px;
    background-color: ${theme.color.white};
    transition: width 0.3s ease-in-out;
  }
  &:hover {
    &::after {
      width: 100%;
    }
  }
`;

const SubMenuContainer = styled.div`
  position: absolute;
  top: 66px;
  left: 0;
  width: 100%;
  background: rgba(17, 18, 19, 0.95);
  border-top: 1px solid ${theme.color.gray900};
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

const SubMenuInner = styled.div`
  display: flex;
  // max-width: 1280px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 12px 16px 16px 24px;
`;

const LeftMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 0 0 124px;
  min-width: 124px;
  padding: 16px 16px 24px 16px;
  margin-right: 52px;
  list-style: none;
`;

const RightMenu = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 16px 0 32px 42px;
  border-left: 1px solid ${theme.color.gray800};
`;
const MenuBadgeTitle = styled.div`
  position: relative;
  max-width: max-content;
`;
